import GavelRoundedIcon from '@mui/icons-material/GavelRounded'
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded'
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded'
import TerminalRoundedIcon from '@mui/icons-material/TerminalRounded'
import type { ArtifactMarker } from '../../types/entity'

const LABELS: Record<ArtifactMarker['type'], string> = {
  DECISION: 'Decision',
  BLOCKER: 'Blocker',
  FOLLOW_UP: 'Follow-up',
  COMMAND: 'Command',
}

const iconFor = (type: ArtifactMarker['type']) => {
  const sx = { fontSize: 14 }
  switch (type) {
    case 'DECISION':
      return <GavelRoundedIcon sx={sx} />
    case 'BLOCKER':
      return <ReportProblemRoundedIcon sx={sx} />
    case 'FOLLOW_UP':
      return <ScheduleRoundedIcon sx={sx} />
    case 'COMMAND':
      return <TerminalRoundedIcon sx={sx} />
  }
}

const MAX_TEXT = 120

export const ArtifactMarkerChip = ({ marker }: { marker: ArtifactMarker }) => {
  const text = marker.text.length > MAX_TEXT ? `${marker.text.slice(0, MAX_TEXT - 1)}…` : marker.text
  return (
    <span
      className={`artifactMarkerChip is-${marker.type.toLowerCase()}`}
      aria-label={`${LABELS[marker.type]} marker`}
      title={marker.text}
    >
      {iconFor(marker.type)}
      <strong>{LABELS[marker.type]}</strong>
      <span>{text}</span>
    </span>
  )
}

export const ArtifactMarkerChipRow = ({ markers }: { markers: ArtifactMarker[] }) => {
  if (!markers || markers.length === 0) return null
  return (
    <div className="artifactMarkerChipRow" role="list">
      {markers.map((marker, index) => (
        <ArtifactMarkerChip key={`${marker.type}-${index}`} marker={marker} />
      ))}
    </div>
  )
}
